import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Button from "shared/components/buttons/Button";
import { useDispatch } from "react-redux";
import InputText from "shared/components/inputs/InputText";
import InputSelect from "shared/components/inputs/InputSelect";
import { updateInviteTemplate } from "redux/actions/updateInviteTemplate";
import "./style.scss";

export default function TabEdit({ template, onClose }) {
   
    const [t] = useTranslation();
    const dispatch = useDispatch();
    const [editableTemplate, setEditableTemplate] = useState(template);



    return editableTemplate && (
        <div className="admin-info">
            <div className="tab-info">
                <div className="section-general">
                    <h2>{t("admin.menu.html.template.review")}</h2>
                </div>

                <div className="divider" />

                <InputText
                    name="htmlMessage"
                    label={t("admin.menu.html.template.message")}
                    value={editableTemplate.approvalMessage}
                    multiline
                    rules={{ required: true }}
                    minRows={5}
                    onChange={({ target }) =>
                        setEditableTemplate(prev => ({
                            ...prev,
                            approvalMessage: target.value
                        }))
                    }
                />

                <InputSelect
                    name="approvalStatus"
                    label={t("admin.menu.html.template.status")}
                    value={editableTemplate.approvalStatus}
                    onChange={({ target }) =>
                        setEditableTemplate(prev => ({
                            ...prev,
                            approvalStatus: target.value
                        }))
                    }
                    items={[
                        { value: "PENDING", label: t("admin.menu.html.status.pending") },
                        { value: "REJECTED", label: t("admin.menu.html.status.rejected") },
                        { value: "APPROVED", label: t("admin.menu.html.status.approved") }
                    ]}
                />


                <div className="button-container">
                    <Button
                        label={t("button.cancel.label")}
                        danger
                        onClick={onClose}

                    />
                    <Button
                        label={t("button.save.label")}
                        onClick={() => {
                            dispatch(updateInviteTemplate(editableTemplate)); 
                            onClose(); 
                        }}

                    />
                </div>
            </div>
        </div>
    );
}


TabEdit.propTypes = {
    organisation: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired
};